export default {"src":"/_next/static/image/public/icons/circle-info.2bfe853a5a5fbc3bfbcd8368334b65b7.svg","height":16,"width":16};